/* eslint-disable no-continue */
import {
  FILTERABLE_CATEGORY_NAMES,
  UNFILTERABLE_ENHANCEMENT_QUALITY_IDS,
} from 'constants/possessions';
import { createSelector } from 'reselect';
import { IAppState } from 'types/app';
import { IEnhancement, IQuality } from 'types/qualities';

const getQualities = (state: IAppState) => state.myself.qualities;

const categoryOrdering: { [key: string]: number } = {
  BasicAbility: 0,
  SidebarAbility: 1,
  Menace: 2,
  Skills: 3,
};

const outputFn = (qualities: IQuality[]) => {
  const enhancementKeyValuePairs: IEnhancement[] = [];
  const { length } = qualities;
  for (let i = 0; i < length; i++) {
    const quality = qualities[i];
    const { enhancements } = quality;

    if (!enhancements) {
      continue;
    }

    if ((enhancements.length ?? 0) <= 0) {
      continue;
    }

    for (let j = 0; j < enhancements.length; j++) {
      const { category, qualityId } = enhancements[j];

      if (FILTERABLE_CATEGORY_NAMES.indexOf(category) < 0) {
        continue;
      }

      if (UNFILTERABLE_ENHANCEMENT_QUALITY_IDS.indexOf(qualityId) >= 0) {
        continue;
      }

      if (enhancementKeyValuePairs.find(item => item.qualityId === qualityId)) {
        continue;
      }

      enhancementKeyValuePairs.push(enhancements[j]);
    }
  }

  return [...enhancementKeyValuePairs]
    .sort((a, b) => {
      if (a.category === b.category) {
        return a.qualityId - b.qualityId;
      }
      return (categoryOrdering[a.category] ?? 0) - (categoryOrdering[b.category] ?? 0);
    });
};

export default createSelector([getQualities], outputFn);
